import { ERealtorRatingTableColumns, RealtorRatingTableSortableColumns } from '../../constants';

/**
 * Проверяет и корректирует значение сортировки для рейтинга риелторов
 * Значение должно входить в ERatingTableColumnHeaders
 */
export const prepareRealtorRatingOrdering = (ordering: string | string[]) => {
  if (!ordering || !ordering.length) {
    return;
  }

  const orderingAsString = typeof ordering === 'string' ? ordering : ordering[0];

  if (
    !(
      Object.values(ERealtorRatingTableColumns).filter(value => RealtorRatingTableSortableColumns[value]) as string[]
    ).includes(orderingAsString)
  ) {
    return;
  }

  return orderingAsString as ERealtorRatingTableColumns;
};
